export default {
  data: () => ({
    mealCategories: [],
    shifts: [],
    selectedShift: null,
  }),
  methods: {
    getDailyDish(dayOrders, category) {
      return dayOrders
        .filter((item) => item.category_name === category)
        .map((meal) => ({
          
          label: `${meal.quantity}x ${meal.meal_name}`,
          quantity: meal.quantity,
          name: meal.meal_name,
          id: meal.food_id
        }));
    },
    setMealCategories(orders) {
      this.mealCategories = [
        ...new Set(orders.map((item) => item.category_name).filter(Boolean)),
      ];
    },
    setShifts(orders) {
      this.shifts = [
        ...new Set(orders.map((item) => item.shift)),
      ].sort((a, b) => a - b);
      this.selectedShift = this.shifts[0];
    },
  },
};
